import type { RefObject } from 'react'

import useScrollOverflow from './useScrollOverflow'

import BottomShadow from './BottomShadow'
import BouncingChevron from './BouncingChevron'
import GradientFade from './GradientFade'
import ScrollPill from './ScrollPill'

interface ScrollOverflowIndicatorProps {
	scrollRef: RefObject<HTMLElement | null>
	showGradientFade?: boolean
	showBouncingChevron?: boolean
	showScrollPill?: boolean
	showBottomShadow?: boolean
	pillText?: string
	threshold?: number
}

export default function ScrollOverflowIndicator({
	scrollRef,
	showGradientFade = false,
	showBouncingChevron = false,
	showScrollPill = false,
	showBottomShadow = false,
	pillText,
	threshold = 20
}: ScrollOverflowIndicatorProps) {
	const { hasOverflow, isAtBottom, hasScrolled } = useScrollOverflow(scrollRef, threshold)

	if (!hasOverflow) return null

	return (
		<>
			{showGradientFade && !isAtBottom && <GradientFade />}
			{showBottomShadow && !isAtBottom && <BottomShadow />}
			{showBouncingChevron && !isAtBottom && !hasScrolled && <BouncingChevron />}
			{showScrollPill && !isAtBottom && !hasScrolled && <ScrollPill text={pillText} />}
		</>
	)
}
